import { useState } from "react";
import { DialogState } from "../taskpane/components/MyDialog";

export function useDialog() {
  const [dialogState, setDialogState] = useState<DialogState>({
    open: false,
    title: "",
    content: "",
  });

  const handleDialogOpen = (
    title: string,
    content: string | JSX.Element,
    actions?: JSX.Element
  ) => {
    setDialogState({
      open: true,
      title: title,
      content: content,
      actions: actions,
    });
  };

  const handleDialogClose = () => {
    setDialogState({
      open: false,
      title: "",
      content: "",
    });
  };
  return {
    dialogState,
    handleDialogOpen,
    handleDialogClose,
  };
}
